import axios, {AxiosError, AxiosRequestConfig} from 'axios';
import {ROUTES} from 'routes/frov/constants';

import {stand} from 'common/api/http';

export const httpCalc = axios.create({
  baseURL: `https"//import-costcalc.xcloud-test.x5.ru/docs/api`,
  timeout: 300000,
});
export const baseURL = stand;
export const AXIOS_INSTANCE = axios.create({timeout: 300000, baseURL}); // use your own URL here or environment variable

export const customInstance = <T>(url: string, config: AxiosRequestConfig = {}): Promise<T> => {
  const source = axios.CancelToken.source();

  // Orval передает body, но axios ожидает data
  const anyConfig = config as any;
  const axiosConfig: AxiosRequestConfig = {
    ...config,
    url,
    cancelToken: source.token,
  };

  // Если есть body (от orval), парсим его в data (для axios)
  if (anyConfig.body) {
    axiosConfig.data = JSON.parse(anyConfig.body);
  }

  // Логирование запроса
  console.log('🚀 API Request:', {
    method: config.method?.toUpperCase() || 'GET',
    url: url,
    baseURL: baseURL,
    fullURL: `${baseURL}${url}`,
    params: config.params,
    body: anyConfig.body,
    data: axiosConfig.data,
    headers: config.headers,
  });

  return AXIOS_INSTANCE(axiosConfig)
    .then(response => {
      console.log('✅ API Response:', {
        status: response.status,
        url: url,
        data: response.data,
      });

      if (response.status === 400) {
        throw new Error(JSON.stringify(response.data));
      } else if (response.status > 400) {
        // костыль, чтобы при логине не обновляло страницу
        // TODO переделать страницу error
        if (window.location.pathname === '/') {
          throw new Error(JSON.stringify(response.data));
        } else {
          window.location.pathname = `${ROUTES.ERROR}/${response.status}`;
        }
      } else {
        return response.data;
      }
    })
    .catch(error => {
      console.error('❌ API Error:', {
        method: config.method?.toUpperCase() || 'GET',
        url: url,
        baseURL: baseURL,
        fullURL: `${baseURL}${url}`,
        status: error.response?.status,
        statusText: error.response?.statusText,
        errorData: error.response?.data,
        errorMessage: error.message,
      });
      throw error;
    });
};
export default customInstance;
export type ErrorType<Error> = AxiosError<Error>;
